/*
 * @Author: young young@sinokru.com
 * @Date: 2023-05-31 09:53:08
 * @LastEditors: young young@sinokru.com
 * @LastEditTime: 2023-10-11 16:23:33
 * @FilePath: /fm_wx_store/src/utils.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  getUrlKey: function(name) {
    return (
      decodeURIComponent(
        (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
          location.href
        ) || [, ""])[1].replace(/\+/g, "%20")
      ) || null
    );
  },
  openTel: function(number) {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    if (isiOS) {
      var message = {
        method: "openTel",
        number: number
      };
      window.webkit.messageHandlers.webViewApp.postMessage(message);
    } else {
      window.findmacau.startFunction(number);
    }
  },
  openLogin: function() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    if (isiOS) {
      var message = {
        method: "openLogin"
      };
      window.webkit.messageHandlers.webViewApp.postMessage(message);
    } else {
      window.findmacau.openLogin();
    }
  },
  openMyCoupon: function() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    if (isiOS) {
      var message = {
        method: "openMyCoupon"
      };
      window.webkit.messageHandlers.webViewApp.postMessage(message);
    } else {
      window.findmacau.openMyCoupon();
    }
  },
  questionBack: function() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    if (isiOS) {
      var message = {
        method: "questionBack"
      };
      window.webkit.messageHandlers.webViewApp.postMessage(message);
    } else {
      window.findmacau.questionBack();
    }
  },
  generateName: function() {
    let time = new Date();
    let y = time.getFullYear();
    let m = time.getMonth() + 1;
    let d = time.getDate();
    let h = time.getHours();
    let mm = time.getMinutes();
    let s = time.getSeconds();
    let ss = time.getTime();
    return "" + y + add0(m) + add0(d) + add0(h) + add0(mm) + add0(s) + ss;
  },

  isPhoneNumber: function(phone) {

    var mobilePatternHK = /^\+852-[5,6,9]\d{7}$/;
    var mobilePatternTW = /^\+886-9\d{8}$/;
    var mobilePatternCN = /^\+86-1[1-9]\d{9}$/;
    var mobilePatternMO = /^\+853-\d{6,8}$/;
    return (
      mobilePatternHK.test(phone) ||
      mobilePatternTW.test(phone) ||
      mobilePatternCN.test(phone) ||
      mobilePatternMO.test(phone)
    );
  },
  isValidEmail: function(email) {
    const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
    return emailRegex.test(email);
  }
};
function add0(m) {
  return m < 10 ? "0" + m : m;
}



// WEBPACK FOOTER //
// ./src/utils.js